var page, countryPath, isMobile;

jQuery(document).ready(function ($) {

    page = $('.landing-main-container').attr('data-page');
    countryPath = $('.landing-main-container').attr('data-countryPath');


    $("a.forcereload").on('click', function () {
        window.location = $(this).attr('href');
        window.location.reload();

    });

    // device detection // if(!isMobile) { }
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;



    /* Carregar el swiper al slide actual */
    var currentPath = window.location.pathname.replace(/\/$/, "");

    var targetIndex = null;

    $('.header-menu .swiper-slide a').each(function (index) {
        var linkHref = $(this).attr('href').replace(/\/$/, "");

        if (linkHref && linkHref === currentPath) {
            targetIndex = index; // Guarda el índice del slide que coincide
            return false;
        }
    });

    var $swiperContainer = $('.header-menu .swiper-container');

    var swiper = new Swiper('.header-menu .swiper-container', {
        slidesPerView: 7,
        spaceBetween: 10,
        // slideToClickedSlide: true,
        initialSlide: 0,
        keyboard: {
            enabled: true,
        },
        breakpoints: {
            400: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            950: {
                slidesPerView: 6,
                spaceBetween: 10,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                if (targetIndex !== null) {
                    this.slideTo(targetIndex, 0); // Moure el Swiper al slide correcte
                }
                // Mostrar el swiper carregat i evitar un salt abans de fer slideTo
                $swiperContainer.fadeTo(100, 1);

            }
        }
    });

    $('.footer-menu .swiper-slide a').each(function (index) {
        var linkHref = $(this).attr('href').replace(/\/$/, "");

        if (linkHref && linkHref === currentPath) {
            targetIndex = index; // Guarda el índice del slide que coincide
            return false;
        }
    });

    var $swiperContainerFooter = $('.footer-menu .swiper-container');

    var swiperfooter = new Swiper('.footer-menu .swiper-container', {
        slidesPerView: 7,
        spaceBetween: 10,
        // slideToClickedSlide: true,
        initialSlide: 0,
        keyboard: {
            enabled: true,
        },
        breakpoints: {
            400: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 10,
            },
            950: {
                slidesPerView: 6,
                spaceBetween: 10,
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            init: function () {
                if (targetIndex !== null) {
                    this.slideTo(targetIndex, 0); // Moure el Swiper al slide correcte
                }
                // Mostrar el swiper carregat i evitar un salt abans de fer slideTo
                $swiperContainerFooter.fadeTo(100, 1);

            }
        }
    });


    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });
    $('a[href=""]').click(function (e) {

        e.preventDefault();
    });
    $('a[href=""]').addClass("inactive");

    $('.no-link').click(function (e) {
        e.preventDefault();
    });

    var currentSeccion = 1;
    var num = '';

    function seccion(num, index) {

        var index = index;
        var auxImgReset = "";
        var i = 0;
        for (i = 1; i < 19; i++) {
            auxImgReset = $('.seccion-menu' + i).attr('src').replace("-filete.png", ".png");
            $('.seccion-menu' + i).attr('src', auxImgReset);
        }

        if ((num == 10) && (index == 9)) {
            var auxImg2 = $('.seccion-menu' + num).attr('src').replace(".png", "-filete.png");
            $('.seccion-menu' + num).attr('src', auxImg2);
            $('.seccion-menu' + num).data('alt-src', auxImg2);
            changefooterbg(index);
            if ($('#footer').hasClass('bg-brown')) {
                var auxImg3 = $('.bg-brown .seccion-menu' + num).attr('src').replace("-filete.png", "-filete-blanco.png");
                $('.bg-brown .seccion-menu' + num).attr('src', auxImg3);
            }
        } else {
            var auxImg2 = $('.seccion-menu' + num).attr('src').replace(".png", "-filete.png");
            $('.seccion-menu' + num).attr('src', auxImg2);
            $('.seccion-menu' + num).data('alt-src', auxImg2);
        }


        window.currentSeccion = num;
        // $('.seccion').fadeOut(300);
        // $('.seccion' + num).fadeIn(300, function () {
        //     $("html, body").animate({ scrollTop: 0 }, "slow");
        // });
        // swiper.slideTo(index);
        // swiperfooter.slideTo(index);

    }

    var sourceSwapImg = function () {
        var $this = $(this).find("img");
        var newSource = $this.data('alt-src');
        $this.data('alt-src', $this.attr('src'));
        $this.attr('src', newSource);



    }

    var sourceSwap = function () {
        var $this = $(this);
        if ($('.menu').hasClass('dark')) {
            var newSource = $this.data('src');
            $this.data('src', $this.attr('src'));
            $this.attr('src', newSource);
        } else {
            var newSource = $this.data('alt-src');
            $this.data('alt-src', $this.attr('src'));
            $this.attr('src', newSource);
        }


    }


    $(function () {

        $('.menu a img').hover(sourceSwap, sourceSwap);
        $('.imagerow a').hover(sourceSwapImg, sourceSwapImg);

    });

    // Normaliza la ruta actual quitando la barra final (si existe)
    var currentPath = window.location.pathname.replace(/\/$/, "");

    $('.swiper-slide a').each(function () {
        var $link = $(this);
        // Normaliza el href del enlace quitando la barra final (si existe)
        var linkHref = $link.attr('href').replace(/\/$/, "");

        // Se cambia la imagen solo si coinciden exactamente
        if (linkHref && linkHref === currentPath) {
            var $img = $link.find('img');
            var altSrc = $img.attr('data-alt-src');
            if (altSrc) {
                $img.attr('src', altSrc);
            }
        }
    });



    var urlGO = window.location.href;
    // if (urlGO.indexOf('#dormirbien') > 0) {
    //     seccion(1, 0);
    // }
    // if (urlGO.indexOf('#ritual') > 0) {
    //     seccion(2, 16);
    // }
    // if (urlGO.indexOf('#almohadas') > 0) {
    //     seccion(3, 15);
    // }
    // if (urlGO.indexOf('#sabanas') > 0) {
    //     seccion(4, 14);
    // }
    // if (urlGO.indexOf('#invitados') > 0) {
    //     seccion(5, 13);
    // }
    // if (urlGO.indexOf('#fuera-pantallas') > 0) {
    //     seccion(6, 12);
    // }
    // if (urlGO.indexOf('#suenos') > 0) {
    //     seccion(7, 11);
    // }
    // if (urlGO.indexOf('#creatividad') > 0) {
    //     seccion(8, 10);
    // }
    // if (urlGO.indexOf('#estiramientos') > 0) {
    //     seccion(9, 9);
    // }
    // if (urlGO.indexOf('#memoria') > 0) {
    //     seccion(10, 8);
    // }
    // if (urlGO.indexOf('#plantas') > 0) {
    //     seccion(11, 7);
    // }
    // if (urlGO.indexOf('#posturas') > 0) {
    //     seccion(12, 6);
    // }
    // if (urlGO.indexOf('#tu-almohada') > 0) {
    //     seccion(13, 5);
    // }
    // if (urlGO.indexOf('#invierno') > 0) {
    //     seccion(14, 4);
    // }
    // if (urlGO.indexOf('#kids') > 0) {
    //     seccion(15, 3);
    // }
    // if (urlGO.indexOf('#outliers') > 0) {
    //     seccion(16, 2);
    // }
    // if (urlGO.indexOf('#casa-saludable') > 0) {
    //     seccion(17, 1);
    // }
    // if (urlGO.indexOf('#lectura') > 0) {
    //     seccion(18, 1);
    // }

    $(document).ready(function () {
        $(".header-menu .swiper-slide a").click(function () {
            var $this = $(this);
            var index;
            if (swiper.clickedIndex) {
                index = swiper.clickedIndex;
            }
            changefooterbg(index);
            seccion(parseInt($this.attr('class')), index);

        });

        $(".footer-menu .swiper-slide a").click(function () {
            var $this = $(this);
            var index;
            if (swiperfooter.clickedIndex) {
                index = swiperfooter.clickedIndex;
            }
            changefooterbg(index);
            seccion(parseInt($this.attr('class')), index);

        });

    });

    function changefooterbg(indexvar) {
        //indexvar cambia en la posicion de estiramientos
        $('#footer').removeClass('bg-brown');
        $('#footer .menu').removeClass('dark');
        if (indexvar == 9) {
            $('#footer').addClass('bg-brown');
            $('#footer .menu').removeClass('light-theme');
            $('#footer .menu').addClass('dark');
        }
    }



    $("#paso1").fadeIn();
    $("#paso2").fadeIn("slow");
    $("#paso3").fadeIn(3000);



});
